import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';
import { canAccessLegalizacao } from './legalizacaoAccess';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function AdminProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, isAuthenticated } = useAdminAuth();
  const { pathname } = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/admin" replace />;
  }

  if (user?.accessLevel !== 'admin' && pathname !== '/admin/dashboard/legalizacao') {
    return <Navigate to="/admin/dashboard/legalizacao" replace />;
  }

  return <>{children}</>;
}
